import React from 'react'
import { NavLink } from 'react-router'
import { LinearProgress, Table, TableBody, TableContainer, Typography } from '@mui/material'
import { normalizedWarrantName } from '@finance-lab/utils/shared'
import { formatDateYYYYMMDD } from '../../../packages/utils/numberFormatters'
import { CompanyEventRow } from './CompanyEventRow'
import SourceApi from '../../../api/SourceApi'
import { useAppLocale } from '../../../i18n/localeUtils'
import { SourceType } from 'types/SourceType'
import { PRInputEntity, WarrantListItem } from '@finance-lab/utils/types'

async function addPRToWarrant(warrant: WarrantListItem, pr: PRInputEntity, sourceType: SourceType) {
    const sourceApi = new SourceApi()
    if (!warrant || !pr || !sourceType) {
        console.error(
            `addPRToWarrant: Missing ${warrant ? '' : 'issue'} ${pr ? '' : 'pr'} ${sourceType ? '' : 'sourceType'}`,
        )
        return null
    }

    const newSource = {
        warrantId: warrant.id,
        sourceType: sourceType,
        prId: pr.id,
    }
    const createdSource = await sourceApi.create(newSource)

    return createdSource
}

export const CompanyWarrants = ({
    warrants,
    sourceType,
    setSourceType,
    selectedPR,
    onArchivePR,
}: {
    onArchivePR: (pr: Pick<PRInputEntity, 'id'>) => void
    setSourceType: (st: SourceType | null) => void
    selectedPR: Pick<PRInputEntity, 'id'>
    sourceType: SourceType | null
    warrants: Array<WarrantListItem> | null
}) => {
    const { language } = useAppLocale()

    if (!warrants) return <LinearProgress />
    if (warrants.length === 0) return <Typography variant='body1'>Inga teckningsoptioner hittades</Typography>

    return (
        <TableContainer>
            <Table>
                <TableBody>
                    {warrants.map((warrant) => {
                        let dates = null
                        if (warrant.subscriptionPeriods?.length === 1) {
                            dates = `${formatDateYYYYMMDD(warrant.subscriptionPeriods[0].subStartDate, { locale: language })} - ${formatDateYYYYMMDD(warrant.subscriptionPeriods[0].subEndDate, { locale: language })}` // prettier-ignore
                        } else if (warrant.subscriptionPeriods?.length > 1) {
                            dates = 'Flera teckningsperioder'
                        }
                        return (
                            <CompanyEventRow
                                key={warrant.id}
                                companyId={warrant.companyId}
                                event={warrant}
                                eventType='warrant'
                                sourceType={sourceType}
                                setSourceType={setSourceType}
                                selectedPR={selectedPR}
                                onCreateSource={addPRToWarrant}
                                onArchivePR={onArchivePR}
                            >
                                <NavLink to={`/admin/warrants/${warrant.id}`} target='_blank'>
                                    {normalizedWarrantName(warrant)}
                                    {!!warrant.unlisted && '(Onoterad)'}
                                </NavLink>
                                {dates && <i>{dates}</i>}
                            </CompanyEventRow>
                        )
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
